import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card } from "react-bootstrap";
import {
  getDoc,
  doc,
  updateDoc,
  writeBatch,
  collection,
  deleteDoc,
  increment,
  serverTimestamp,
  arrayRemove,
  arrayUnion,
} from "firebase/firestore";
import { toast } from "react-toastify";
import { db } from "../FirebaseConfig";
import { UserAuth } from "../Context";
import { toastOptions } from "../lib/toastOptions";
import useFavStore from "../StatesStore/FavStore";
import useModalStore from "../StatesStore/ModalStore";
import formatPrice from "../lib/formatPrice";
import useNotification from "../hooks/useNotification";
import useShoppingListProductsStore from "../StatesStore/ShoppingListProducts";
import AddToCart from "../components/AddToCart";
import BrandDisplay from "../NewsFeed/BrandDisplay";
import AddOrRemoveLike from "../Products/AddOrRemoveLike";
import { getBrandDetails } from "../lib/getBrandDetails";
import useActiveBrandsStore from "../StatesStore/ActiveBrands";
import AddToList from "../components/AddToList";
import AddToChat3 from "../components/AddToChat3";
import AddToFavorites from "../UserProfile/ProfileShoppingList/AddToFavorites";
import ProductCardBottom from "../Products/ProductCardBottom";
const ShoppingListCard2 = ({ product, id, listName, role, ownerId, type }) => {
  const { user } = UserAuth();
  const [brandData, setBrandData] = useState(null);
  const [productData, setProductData] = useState(null);
  const [isLiked, setIsLiked] = useState(false);
  const [isDisliked, setIsDisliked] = useState(false);
  const [likeCount, setLikeCount] = useState(product?.likes?.length ?? 0);
  const [dislikeCount, setDislikeCount] = useState(
    product?.dislikes?.length ?? 0
  );
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const [showCard, setShowCard] = useState(true);
  // const [hasLoadedBrandData, setHasLoadedBrandData] = useState(false);
  const { openModal } = useModalStore();
  const removeFavoriteProduct = useFavStore((state) => state.removeFavorite);
  const { addNotification, deleteNotification } = useNotification();
  const setProductDataInStore = useShoppingListProductsStore(
    (state) => state.addProduct
  );
  const activeBrands = useActiveBrandsStore((state) => state.activeBrands);
  const fetchBrandData = async () => {
    try {
      // Fetch the brand's display name and logo using the getDisplayName function
      const result = await getBrandDetails(productData?.supplier, activeBrands);
      setBrandData(result);
    } catch (error) {
      console.error("Error getting brand data:", error);
    }
  };
  useEffect(() => {
    if (!productData || !activeBrands) return;
    fetchBrandData();
  }, [productData, activeBrands]);

  useEffect(() => {
    const fetchProduct = async () => {
      if (product?.id) {
        const productRef = doc(db, "products", product?.id);
        const productSnapshot = await getDoc(productRef);
        if (productSnapshot.exists()) {
          const fetchedProductData = { ...productSnapshot.data(), ...product };
          setProductData({ ...productSnapshot.data(), ...product });
          setProductDataInStore(id, fetchedProductData);
          const batch = writeBatch(db);
          const incrementViews = {
            views: productSnapshot.data()?.views
              ? productSnapshot.data()?.views + 1
              : 1,
          };
          batch.update(doc(db, "products", product?.id), incrementViews);
          batch.commit();
        }
      }
    };

    fetchProduct();
  }, [product?.id]);
  const handleTrashIconClick = async () => {
    if (!user) return;
    console.log("role", role);
    if (role === "viewer" || role === "commentor") {
      toast.warn(
        "You do not have permissions to delete any product.",
        toastOptions
      );
      return;
    }
    if (!ownerId) {
      console.error("ownerId is undefined");
      return;
    }
    if (!id) {
      console.error("shopping list id is undefined");
      return;
    }
    if (!product?.id) {
      console.error("product id is undefined");
      return;
    }
    const userRef = doc(db, "users", ownerId);
    const shoppingListRef = collection(userRef, "shoppingList");

    try {
      const listDocRef = doc(shoppingListRef, id);
      const listDoc = await getDoc(listDocRef);

      if (listDoc.exists()) {
        // Check visibility and user role

        // Handle product deletion from the 'products' subcollection
        const productRef = doc(listDocRef, "products", product?.id);

        // Check if the product document exists
        const productDoc = await getDoc(productRef);
        if (productDoc.exists()) {
          // Delete the product document from the 'products' subcollection
          await deleteDoc(productRef);

          // Update the inShoppingList entry
          // const productInShoppingListRef = doc(
          //   db,
          //   "products",
          //   product.id,
          //   "inShoppingList",
          //   user.uid
          // );
          // const inShoppingListDoc = await getDoc(productInShoppingListRef);
          // if (inShoppingListDoc.exists()) {
          //   const { listNames } = inShoppingListDoc.data();
          //   const newListNames = listNames.filter((name) => name !== id);
          //   if (newListNames.length === 0) {
          //     // If no more lists contain this product, remove the document
          //     await deleteDoc(productInShoppingListRef);
          //   } else {
          //     // Otherwise, update the document with the new list of names
          //     await updateDoc(productInShoppingListRef, {
          //       listNames: newListNames,
          //     });
          //   }
          // }

          // Decrement the shoppingListCount
          await updateDoc(userRef, {
            shoppingListCount: increment(-1),
          });

          if (id === "Favorites") {
            removeFavoriteProduct(product?.id);
          }

          toast.success(
            `${productData?.name} removed from ${id}`,
            toastOptions
          );
        } else {
          console.error("Product not found in the list.");
        }
        await updateDoc(listDocRef, {
          lastUpdated: serverTimestamp(),
        });
      } else {
        console.error("List document does not exist.");
      }
    } catch (error) {
      console.error(
        "Error removing product from shopping list:",
        error.message
      );
    }
  };

  const handleClick = () => {
    const DATA = {
      deleteFunction: handleTrashIconClick,
      displayName: productData?.name,
      shoppingListName: listName,
    };
    openModal("ConfirmDelete", "shoppingListProduct", DATA);
  };

  useEffect(() => {
    if (productData) fetchBrandData();
  }, [productData]);

  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const checkIfLiked = async () => {
      if (user && productData?.id && product?.likes) {
        setIsLiked(product?.likes?.includes(user?.uid));
      }
    };

    const checkIfDisliked = async () => {
      if (user && productData?.id && product?.dislikes) {
        setIsDisliked(product?.dislikes?.includes(user?.uid));
      }
    };

    checkIfLiked();
    checkIfDisliked();
  }, [user, productData?.id]);

  const handleLike = async () => {
    if (!user) {
      toast.warn("You must be logged in to like a product.", toastOptions);
      return;
    }
    const productRef = doc(
      db,
      "users",
      ownerId,
      "shoppingList",
      id,
      "products",
      productData?.id
    );
    if (isDisliked) {
      setIsDisliked(false);
      setDislikeCount((prev) => prev - 1);
      await updateDoc(productRef, {
        dislikes: arrayRemove(user?.uid),
      });
    }
    if (isLiked) {
      setIsLiked(false);
      setLikeCount((prev) => prev - 1);
      await updateDoc(productRef, {
        likes: arrayRemove(user?.uid),
      });
    } else {
      setIsLiked(true);
      setLikeCount((prev) => prev + 1);
      await updateDoc(productRef, {
        likes: arrayUnion(user?.uid),
      });
    }
  };
  const handleDislike = async () => {
    if (!user) {
      toast.warn("You must be logged in to dislike a product.", toastOptions);
      return;
    }
    const productRef = doc(
      db,
      "users",
      ownerId,
      "shoppingList",
      id,
      "products",
      productData?.id
    );
    if (isLiked) {
      setIsLiked(false);
      setLikeCount((prev) => prev - 1);
      await updateDoc(productRef, {
        likes: arrayRemove(user?.uid),
      });
    }
    if (isDisliked) {
      setIsDisliked(false);
      setDislikeCount((prev) => prev - 1);
      await updateDoc(productRef, {
        dislikes: arrayRemove(user?.uid),
      });
    } else {
      setIsDisliked(true);
      setDislikeCount((prev) => prev + 1);
      await updateDoc(productRef, {
        dislikes: arrayUnion(user?.uid),
      });
    }
  };
  return (
    product && (
      <div
        className="d-flex flex-column justify-content-between col-6 col-sm-4 col-md-3 col-lg-20"
        style={{ padding: isSmallScreen ? "6px 1.5px" : "8px 4px" }}
      >
        <div
          style={{
            position: "relative",
            width: "100%",
            height: "280px",
          }}
        >
          {showCard ? (
            <>
              <Link to={`/ProductDetails/${productData?.id}`}>
                <Card.Img
                  src={productData?.imageUrl}
                  style={{
                    opacity: 1, // Hide the image until it's fully loaded
                    transition: "opacity 0.5s ease-in-out",
                    objectFit: "cover",
                    objectPosition: "top",
                    height: "100%",
                    display: "inline",
                    borderRadius: "6px 6px 0px 0px",
                    // objectPosition: "top",
                    filter: "contrast(1.1) brightness(0.95)",
                  }}
                  onError={() => setShowCard(false)}
                  loading="lazy"
                />
              </Link>
            </>
          ) : (
            <Link to={`/ProductDetails/${productData?.id}`}>
              <Card.Img
                className="rounded-2 skeleton"
                style={{
                  transition: "opacity 0.5s ease-in-out",
                  objectFit: "cover",
                  height: isSmallScreen ? "80%" : "14rem",
                  display: "inline",
                  objectPosition: "top",
                }}
                loading="lazy"
              />
            </Link>
          )}
          <div
            className="d-flex align-items-center"
            style={{
              position: "absolute",
              bottom: "3px",
              right: "3px",
              gap: "3px",
            }}
          >
            <div
              style={{
                zIndex: 1,
                width: "24px",
                height: "24px",
                backgroundColor: "#FFFFFF",
                borderRadius: "2px",
              }}
              className="d-flex justify-content-center align-items-center"
            >
              <AddToFavorites
                userId={user?.uid}
                productId={productData?.id}
                product={productData}
                type={"product"}
              />
            </div>
          </div>
          <div
            className="d-flex align-items-center"
            style={{
              position: "absolute",
              top: "3px",
              right: "3px",
              gap: "3px",
            }}
          >
            {productData?.discount > 0 && (
              <div
                style={{
                  zIndex: 1,
                  backgroundColor: "#FFE1DC",
                  height: "20px",
                  borderRadius: "2px 4px 2px 2px",
                  width: "47px",
                }}
                className="d-flex justify-content-center align-items-center"
              >
                <div
                  style={{
                    fontFamily: "Inter",
                    fontWeight: "400",
                    textAlign: "center",
                    fontSize: "11px",
                    letterSpacing: "0%",
                    color: "#FF4424",
                  }}
                >
                  -{productData?.discount ?? "0"}%
                </div>
              </div>
            )}
          </div>
          <Link
            to={`/ProductDetails/${product?.id}`}
            style={{
              position: "absolute",
              width: "100%",
              height: "12%",
              opacity: "60%",
              bottom: "0%",
              left: "0%",
              background:
                "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%)",
            }}
          ></Link>
          <div
            className="d-flex"
            style={{
              position: "absolute",
              bottom: "4px",
              left: "3px",
              gap: "12px",
            }}
          >
            <div
              className="d-flex"
              style={{ gap: "4px", cursor: "pointer" }}
              onClick={handleLike}
            >
              {isLiked ? (
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2 7.32284L2.49814 7.27977C2.47507 7.013 2.24595 6.81176 1.97845 6.8233C1.71093 6.83484 1.5 7.05508 1.5 7.32284H2ZM13.4907 8.5383L13.0204 11.2581L14.0058 11.4286L14.4761 8.7087L13.4907 8.5383ZM8.83 14.6667H5.7309V15.6667H8.83V14.6667ZM5.12332 14.1084L4.58188 7.84657L3.5856 7.9327L4.12704 14.1945L5.12332 14.1084ZM13.0204 11.2581C12.6825 13.2118 10.9209 14.6667 8.83 14.6667V15.6667C11.3808 15.6667 13.5805 13.8874 14.0058 11.4286L13.0204 11.2581ZM8.83653 3.90014L8.39473 6.59652L9.3816 6.7582L9.8234 4.06183L8.83653 3.90014ZM4.79182 7.33044L5.75098 6.50394L5.09819 5.7464L4.13903 6.57292L4.79182 7.33044ZM7.496 3.81474L7.81313 2.59218L6.8452 2.34108L6.52805 3.56365L7.496 3.81474ZM8.29213 2.35231L8.3888 2.38336L8.69467 1.43128L8.598 1.40024L8.29213 2.35231ZM7.01567 5.04403C7.2236 4.65469 7.38513 4.2423 7.496 3.81474L6.52805 3.56365C6.43715 3.91408 6.30466 4.25266 6.13361 4.57286L7.01567 5.04403ZM8.3888 2.38336C8.59307 2.44898 8.73813 2.60676 8.7858 2.7906L9.7538 2.53951C9.6168 2.0115 9.21267 1.59769 8.69467 1.43128L8.3888 2.38336ZM7.81313 2.59218C7.83653 2.50217 7.90153 2.41946 7.99987 2.37206L7.56573 1.4712C7.21107 1.6421 6.94467 1.95755 6.8452 2.34108L7.81313 2.59218ZM7.99987 2.37206C8.08967 2.32878 8.1954 2.32124 8.29213 2.35231L8.598 1.40024C8.2582 1.29107 7.88747 1.31617 7.56573 1.4712L7.99987 2.37206ZM9.4358 7.82284H12.8899V6.82284H9.4358V7.82284ZM3.14587 14.7708L2.49814 7.27977L1.50186 7.3659L2.14959 14.8569L3.14587 14.7708ZM2.5 14.8418V7.32284H1.5V14.8418H2.5ZM2.14959 14.8569C2.1408 14.7552 2.22097 14.6667 2.32447 14.6667V15.6667C2.80845 15.6667 3.18748 15.252 3.14587 14.7708L2.14959 14.8569ZM9.8234 4.06183C9.9064 3.55508 9.88273 3.03656 9.7538 2.53951L8.7858 2.7906C8.8798 3.15286 8.89707 3.53078 8.83653 3.90014L9.8234 4.06183ZM5.7309 14.6667C5.41496 14.6667 5.15067 14.4247 5.12332 14.1084L4.12704 14.1945C4.19901 15.0268 4.89513 15.6667 5.7309 15.6667V14.6667ZM5.75098 6.50394C6.20421 6.11337 6.6928 5.64848 7.01567 5.04403L6.13361 4.57286C5.90269 5.00515 5.535 5.36999 5.09819 5.7464L5.75098 6.50394ZM14.4761 8.7087C14.6463 7.72437 13.8894 6.82284 12.8899 6.82284V7.82284C13.2676 7.82284 13.5555 8.16397 13.4907 8.5383L14.4761 8.7087ZM2.32447 14.6667C2.42195 14.6667 2.5 14.7456 2.5 14.8418H1.5C1.5 15.2969 1.86859 15.6667 2.32447 15.6667V14.6667ZM8.39473 6.59652C8.2896 7.23844 8.7844 7.82284 9.4358 7.82284V6.82284C9.40253 6.82284 9.37593 6.79271 9.3816 6.7582L8.39473 6.59652ZM4.58188 7.84657C4.56493 7.65057 4.64317 7.45857 4.79182 7.33044L4.13903 6.57292C3.74681 6.91091 3.54099 7.4169 3.5856 7.9327L4.58188 7.84657Z"
                    fill="white"
                  />
                  <path
                    d="M10.5 15H5.5L4.5 14.5L4 8.5L4.5 7L6.5 4.5L7 2.5L8.5 1.5L9.5 3L9 7L10 7.5H13.5L14 9.5L12.5 13.5L10.5 15Z"
                    fill="white"
                  />
                </svg>
              ) : (
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2 7.32284L2.49814 7.27977C2.47507 7.013 2.24595 6.81176 1.97845 6.8233C1.71093 6.83484 1.5 7.05508 1.5 7.32284H2ZM13.4907 8.5383L13.0204 11.2581L14.0058 11.4286L14.4761 8.7087L13.4907 8.5383ZM8.83 14.6667H5.7309V15.6667H8.83V14.6667ZM5.12332 14.1084L4.58188 7.84657L3.5856 7.9327L4.12704 14.1945L5.12332 14.1084ZM13.0204 11.2581C12.6825 13.2118 10.9209 14.6667 8.83 14.6667V15.6667C11.3808 15.6667 13.5805 13.8874 14.0058 11.4286L13.0204 11.2581ZM8.83653 3.90014L8.39473 6.59652L9.3816 6.7582L9.8234 4.06183L8.83653 3.90014ZM4.79182 7.33044L5.75098 6.50394L5.09819 5.7464L4.13903 6.57292L4.79182 7.33044ZM7.496 3.81474L7.81313 2.59218L6.8452 2.34108L6.52805 3.56365L7.496 3.81474ZM8.29213 2.35231L8.3888 2.38336L8.69467 1.43128L8.598 1.40024L8.29213 2.35231ZM7.01567 5.04403C7.2236 4.65469 7.38513 4.2423 7.496 3.81474L6.52805 3.56365C6.43715 3.91408 6.30466 4.25266 6.13361 4.57286L7.01567 5.04403ZM8.3888 2.38336C8.59307 2.44898 8.73813 2.60676 8.7858 2.7906L9.7538 2.53951C9.6168 2.0115 9.21267 1.59769 8.69467 1.43128L8.3888 2.38336ZM7.81313 2.59218C7.83653 2.50217 7.90153 2.41946 7.99987 2.37206L7.56573 1.4712C7.21107 1.6421 6.94467 1.95755 6.8452 2.34108L7.81313 2.59218ZM7.99987 2.37206C8.08967 2.32878 8.1954 2.32124 8.29213 2.35231L8.598 1.40024C8.2582 1.29107 7.88747 1.31617 7.56573 1.4712L7.99987 2.37206ZM9.4358 7.82284H12.8899V6.82284H9.4358V7.82284ZM3.14587 14.7708L2.49814 7.27977L1.50186 7.3659L2.14959 14.8569L3.14587 14.7708ZM2.5 14.8418V7.32284H1.5V14.8418H2.5ZM2.14959 14.8569C2.1408 14.7552 2.22097 14.6667 2.32447 14.6667V15.6667C2.80845 15.6667 3.18748 15.252 3.14587 14.7708L2.14959 14.8569ZM9.8234 4.06183C9.9064 3.55508 9.88273 3.03656 9.7538 2.53951L8.7858 2.7906C8.8798 3.15286 8.89707 3.53078 8.83653 3.90014L9.8234 4.06183ZM5.7309 14.6667C5.41496 14.6667 5.15067 14.4247 5.12332 14.1084L4.12704 14.1945C4.19901 15.0268 4.89513 15.6667 5.7309 15.6667V14.6667ZM5.75098 6.50394C6.20421 6.11337 6.6928 5.64848 7.01567 5.04403L6.13361 4.57286C5.90269 5.00515 5.535 5.36999 5.09819 5.7464L5.75098 6.50394ZM14.4761 8.7087C14.6463 7.72437 13.8894 6.82284 12.8899 6.82284V7.82284C13.2676 7.82284 13.5555 8.16397 13.4907 8.5383L14.4761 8.7087ZM2.32447 14.6667C2.42195 14.6667 2.5 14.7456 2.5 14.8418H1.5C1.5 15.2969 1.86859 15.6667 2.32447 15.6667V14.6667ZM8.39473 6.59652C8.2896 7.23844 8.7844 7.82284 9.4358 7.82284V6.82284C9.40253 6.82284 9.37593 6.79271 9.3816 6.7582L8.39473 6.59652ZM4.58188 7.84657C4.56493 7.65057 4.64317 7.45857 4.79182 7.33044L4.13903 6.57292C3.74681 6.91091 3.54099 7.4169 3.5856 7.9327L4.58188 7.84657Z"
                    fill="white"
                  />
                </svg>
              )}
              <div
                style={{
                  fontFamily: "Inter",
                  fontWeight: 400,
                  fontSize: "16px",
                  lineHeight: "100%",
                  letterSpacing: "0%",
                  color: "white",
                  minWidth: "10px",
                }}
              >
                {likeCount}
              </div>
            </div>
            <div
              className="d-flex"
              style={{ gap: "4px", cursor: "pointer" }}
              onClick={handleDislike}
            >
              {isDisliked ? (
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2 9.67724L2.49814 9.72031C2.47507 9.98711 2.24595 10.1883 1.97845 10.1768C1.71093 10.1652 1.5 9.94497 1.5 9.67724H2ZM13.4907 8.46177L13.0204 5.74194L14.0058 5.57153L14.4761 8.29138L13.4907 8.46177ZM8.83 2.33337H5.7309V1.33337H8.83V2.33337ZM5.12332 2.89173L4.58188 9.15351L3.5856 9.06737L4.12704 2.80559L5.12332 2.89173ZM13.0204 5.74194C12.6825 3.78821 10.9209 2.33337 8.83 2.33337V1.33337C11.3808 1.33337 13.5805 3.11267 14.0058 5.57153L13.0204 5.74194ZM8.83653 13.0999L8.39473 10.4036L9.3816 10.2419L9.8234 12.9382L8.83653 13.0999ZM4.79182 9.66964L5.75098 10.4962L5.09819 11.2537L4.13903 10.4272L4.79182 9.66964ZM7.496 13.1853L7.81313 14.4079L6.8452 14.659L6.52805 13.4364L7.496 13.1853ZM8.29213 14.6478L8.3888 14.6167L8.69467 15.5688L8.598 15.5998L8.29213 14.6478ZM7.01567 11.956C7.2236 12.3454 7.38513 12.7578 7.496 13.1853L6.52805 13.4364C6.43715 13.086 6.30466 12.7474 6.13361 12.4272L7.01567 11.956ZM8.3888 14.6167C8.59307 14.5511 8.73813 14.3933 8.7858 14.2095L9.7538 14.4606C9.6168 14.9886 9.21267 15.4024 8.69467 15.5688L8.3888 14.6167ZM7.81313 14.4079C7.83653 14.4979 7.90153 14.5806 7.99987 14.628L7.56573 15.5289C7.21107 15.358 6.94467 15.0425 6.8452 14.659L7.81313 14.4079ZM7.99987 14.628C8.08967 14.6713 8.1954 14.6788 8.29213 14.6478L8.598 15.5998C8.2582 15.709 7.88747 15.6839 7.56573 15.5289L7.99987 14.628ZM9.4358 9.17724H12.8899V10.1772H9.4358V9.17724ZM3.14587 2.2293L2.49814 9.72031L1.50186 9.63417L2.14959 2.14315L3.14587 2.2293ZM2.5 2.15821V9.67724H1.5V2.15821H2.5ZM2.14959 2.14315C2.1408 2.24485 2.22097 2.33337 2.32447 2.33337V1.33337C2.80845 1.33337 3.18748 1.74811 3.14587 2.2293L2.14959 2.14315ZM9.8234 12.9382C9.9064 13.445 9.88273 13.9635 9.7538 14.4606L8.7858 14.2095C8.8798 13.8472 8.89707 13.4693 8.83653 13.0999L9.8234 12.9382ZM5.7309 2.33337C5.41496 2.33337 5.15067 2.57539 5.12332 2.89173L4.12704 2.80559C4.19901 1.97321 4.89513 1.33337 5.7309 1.33337V2.33337ZM5.75098 10.4962C6.20421 10.8867 6.6928 11.3516 7.01567 11.956L6.13361 12.4272C5.90269 11.9949 5.535 11.6301 5.09819 11.2537L5.75098 10.4962ZM14.4761 8.29138C14.6463 9.27571 13.8894 10.1772 12.8899 10.1772V9.17724C13.2676 9.17724 13.5555 8.83611 13.4907 8.46177L14.4761 8.29138ZM2.32447 2.33337C2.42195 2.33337 2.5 2.25441 2.5 2.15821H1.5C1.5 1.7032 1.86859 1.33337 2.32447 1.33337V2.33337ZM8.39473 10.4036C8.2896 9.76164 8.7844 9.17724 9.4358 9.17724V10.1772C9.40253 10.1772 9.37593 10.2074 9.3816 10.2419L8.39473 10.4036ZM4.58188 9.15351C4.56493 9.34951 4.64317 9.54151 4.79182 9.66964L4.13903 10.4272C3.74681 10.0892 3.54099 9.58317 3.5856 9.06737L4.58188 9.15351Z"
                    fill="white"
                  />
                  <path
                    d="M13.5 9.5H12L9 10V10.5L9.5 14.5L8.5 15H7.5L6.5 12L4.5 10.5L4 9L4.5 5L5 2H11L13 4L14 9L13.5 9.5Z"
                    fill="white"
                  />
                </svg>
              ) : (
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2 9.67724L2.49814 9.72031C2.47507 9.98711 2.24595 10.1883 1.97845 10.1768C1.71093 10.1652 1.5 9.94497 1.5 9.67724H2ZM13.4907 8.46177L13.0204 5.74194L14.0058 5.57153L14.4761 8.29138L13.4907 8.46177ZM8.83 2.33337H5.7309V1.33337H8.83V2.33337ZM5.12332 2.89173L4.58188 9.15351L3.5856 9.06737L4.12704 2.80559L5.12332 2.89173ZM13.0204 5.74194C12.6825 3.78821 10.9209 2.33337 8.83 2.33337V1.33337C11.3808 1.33337 13.5805 3.11267 14.0058 5.57153L13.0204 5.74194ZM8.83653 13.0999L8.39473 10.4036L9.3816 10.2419L9.8234 12.9382L8.83653 13.0999ZM4.79182 9.66964L5.75098 10.4962L5.09819 11.2537L4.13903 10.4272L4.79182 9.66964ZM7.496 13.1853L7.81313 14.4079L6.8452 14.659L6.52805 13.4364L7.496 13.1853ZM8.29213 14.6478L8.3888 14.6167L8.69467 15.5688L8.598 15.5998L8.29213 14.6478ZM7.01567 11.956C7.2236 12.3454 7.38513 12.7578 7.496 13.1853L6.52805 13.4364C6.43715 13.086 6.30466 12.7474 6.13361 12.4272L7.01567 11.956ZM8.3888 14.6167C8.59307 14.5511 8.73813 14.3933 8.7858 14.2095L9.7538 14.4606C9.6168 14.9886 9.21267 15.4024 8.69467 15.5688L8.3888 14.6167ZM7.81313 14.4079C7.83653 14.4979 7.90153 14.5806 7.99987 14.628L7.56573 15.5289C7.21107 15.358 6.94467 15.0425 6.8452 14.659L7.81313 14.4079ZM7.99987 14.628C8.08967 14.6713 8.1954 14.6788 8.29213 14.6478L8.598 15.5998C8.2582 15.709 7.88747 15.6839 7.56573 15.5289L7.99987 14.628ZM9.4358 9.17724H12.8899V10.1772H9.4358V9.17724ZM3.14587 2.2293L2.49814 9.72031L1.50186 9.63417L2.14959 2.14315L3.14587 2.2293ZM2.5 2.15821V9.67724H1.5V2.15821H2.5ZM2.14959 2.14315C2.1408 2.24485 2.22097 2.33337 2.32447 2.33337V1.33337C2.80845 1.33337 3.18748 1.74811 3.14587 2.2293L2.14959 2.14315ZM9.8234 12.9382C9.9064 13.445 9.88273 13.9635 9.7538 14.4606L8.7858 14.2095C8.8798 13.8472 8.89707 13.4693 8.83653 13.0999L9.8234 12.9382ZM5.7309 2.33337C5.41496 2.33337 5.15067 2.57539 5.12332 2.89173L4.12704 2.80559C4.19901 1.97321 4.89513 1.33337 5.7309 1.33337V2.33337ZM5.75098 10.4962C6.20421 10.8867 6.6928 11.3516 7.01567 11.956L6.13361 12.4272C5.90269 11.9949 5.535 11.6301 5.09819 11.2537L5.75098 10.4962ZM14.4761 8.29138C14.6463 9.27571 13.8894 10.1772 12.8899 10.1772V9.17724C13.2676 9.17724 13.5555 8.83611 13.4907 8.46177L14.4761 8.29138ZM2.32447 2.33337C2.42195 2.33337 2.5 2.25441 2.5 2.15821H1.5C1.5 1.7032 1.86859 1.33337 2.32447 1.33337V2.33337ZM8.39473 10.4036C8.2896 9.76164 8.7844 9.17724 9.4358 9.17724V10.1772C9.40253 10.1772 9.37593 10.2074 9.3816 10.2419L8.39473 10.4036ZM4.58188 9.15351C4.56493 9.34951 4.64317 9.54151 4.79182 9.66964L4.13903 10.4272C3.74681 10.0892 3.54099 9.58317 3.5856 9.06737L4.58188 9.15351Z"
                    fill="white"
                  />
                </svg>
              )}

              <div
                style={{
                  fontFamily: "Inter",
                  fontWeight: 400,
                  fontSize: "16px",
                  lineHeight: "100%",
                  letterSpacing: "0%",
                  color: "white",
                  minWidth: "10px",
                }}
              >
                {dislikeCount}
              </div>
            </div>
          </div>
        </div>

        <div
          className={`d-flex justify-content-between flex-column`}
          style={{
            gap: isSmallScreen ? "8px" : "8px",
            padding: isSmallScreen ? "6px 3px 3px 3px" : "6px 3px 3px 3px",
            borderRadius: "0px 0px 6px 6px",
            borderWidth: "0px 1px 1px 1px",
            borderStyle: "solid",
            borderColor: "#0000001A",
          }}
        >
          <div
            className="d-flex w-100 align-items-center"
            style={{ gap: isSmallScreen ? "2px" : "2px" }}
          >
            <div
              className="d-flex flex-column"
              style={{
                gap: isSmallScreen ? "2px" : "2px",
                width: "86%",
              }}
            >
              <Link
                to={`/BrandHome/${brandData?.name}`}
                style={{
                  fontFamily: "Inter",
                  fontWeight: "400",
                  fontSize: isSmallScreen ? "12px" : "13px",
                  lineHeight: "100%",
                  letterSpacing: "0%",
                  color: "#676A79",
                }}
              >
                {brandData?.displayName}
              </Link>
              <Link
                to={`/ProductDetails/${productData?.id}`}
                className="text-truncate"
                title={product?.name}
                style={{
                  fontFamily: "Inter",
                  fontWeight: "600",
                  fontSize: isSmallScreen ? "13px" : "13px",
                  letterSpacing: "0%",
                  color: "#000000",
                }}
              >
                {productData?.name}
              </Link>
            </div>
            {type === "myList" && (
              <div
                style={{
                  width: "24px",
                  height: "24px",
                  borderRadius: "40px",
                  borderWidth: "1px",
                  border: "1px solid #14191F",
                  cursor: "pointer",
                }}
                className="d-flex justify-content-center align-items-center"
                onClick={handleClick}
              >
                <svg
                  width="16"
                  height="15"
                  viewBox="0 0 16 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_1533_23226)">
                    <path
                      d="M14.5625 2.68725H10.2969C10.1893 2.19275 9.90185 1.74817 9.48325 1.42884C9.06465 1.1095 8.54064 0.935059 8 0.935059C7.45936 0.935059 6.93535 1.1095 6.51675 1.42884C6.09815 1.74817 5.81071 2.19275 5.70312 2.68725H1.4375C1.31318 2.68725 1.19395 2.73335 1.10604 2.81539C1.01814 2.89744 0.96875 3.00872 0.96875 3.12475C0.96875 3.24078 1.01814 3.35206 1.10604 3.43411C1.19395 3.51616 1.31318 3.56225 1.4375 3.56225H14.5625C14.6868 3.56225 14.806 3.51616 14.894 3.43411C14.9819 3.35206 15.0312 3.24078 15.0312 3.12475C15.0312 3.00872 14.9819 2.89744 14.894 2.81539C14.806 2.73335 14.6868 2.68725 14.5625 2.68725ZM8 1.81225C8.29013 1.81301 8.57291 1.89751 8.80956 2.05416C9.04622 2.21081 9.22517 2.43195 9.32187 2.68725H6.67813C6.77483 2.43195 6.95378 2.21081 7.19044 2.05416C7.42709 1.89751 7.70987 1.81301 8 1.81225ZM12.8656 4.47225C12.7803 4.43875 12.6862 4.42959 12.5952 4.44595C12.5043 4.4623 12.4206 4.50342 12.3547 4.56413C12.3112 4.60501 12.2769 4.65349 12.2535 4.70679C12.2302 4.7601 12.2184 4.81717 12.2188 4.87475C12.2188 4.99078 12.2681 5.10206 12.356 5.18411C12.444 5.26616 12.5632 5.31225 12.6875 5.31225C12.8118 5.31225 12.931 5.26616 13.019 5.18411C13.1069 5.10206 13.1562 4.99078 13.1562 4.87475C13.1545 4.75892 13.106 4.64797 13.0203 4.56413C12.9757 4.5243 12.9232 4.49307 12.8656 4.47225ZM12.6875 6.18725C12.5632 6.18725 12.444 6.23335 12.356 6.31539C12.2681 6.39744 12.2188 6.50872 12.2188 6.62475V7.93725C12.2188 8.05328 12.2681 8.16456 12.356 8.24661C12.444 8.32866 12.5632 8.37475 12.6875 8.37475C12.8118 8.37475 12.931 8.32866 13.019 8.24661C13.1069 8.16456 13.1562 8.05328 13.1562 7.93725V6.62475C13.1562 6.50872 13.1069 6.39744 13.019 6.31539C12.931 6.23335 12.8118 6.18725 12.6875 6.18725ZM12.6875 9.24975C12.5632 9.24975 12.444 9.29585 12.356 9.37789C12.2681 9.45994 12.2188 9.57122 12.2188 9.68725V12.7498C12.2188 12.8658 12.1694 12.9771 12.0815 13.0591C11.9935 13.1412 11.8743 13.1873 11.75 13.1873H4.25C4.12568 13.1873 4.00645 13.1412 3.91854 13.0591C3.83064 12.9771 3.78125 12.8658 3.78125 12.7498V4.87475C3.78125 4.75872 3.73186 4.64744 3.64396 4.56539C3.55605 4.48335 3.43682 4.43725 3.3125 4.43725C3.18818 4.43725 3.06895 4.48335 2.98104 4.56539C2.89314 4.64744 2.84375 4.75872 2.84375 4.87475V12.7498C2.84375 13.0978 2.99191 13.4317 3.25563 13.6778C3.51935 13.924 3.87704 14.0623 4.25 14.0623H11.75C12.123 14.0623 12.4806 13.924 12.7444 13.6778C13.0081 13.4317 13.1562 13.0978 13.1562 12.7498V9.68725C13.1562 9.57122 13.1069 9.45994 13.019 9.37789C12.931 9.29585 12.8118 9.24975 12.6875 9.24975Z"
                      fill="#231815"
                    />
                    <path
                      d="M6.125 11V5.3125C6.125 5.19647 6.07561 5.08519 5.98771 5.00314C5.8998 4.92109 5.78057 4.875 5.65625 4.875C5.53193 4.875 5.4127 4.92109 5.32479 5.00314C5.23689 5.08519 5.1875 5.19647 5.1875 5.3125V11C5.1875 11.116 5.23689 11.2273 5.32479 11.3094C5.4127 11.3914 5.53193 11.4375 5.65625 11.4375C5.78057 11.4375 5.8998 11.3914 5.98771 11.3094C6.07561 11.2273 6.125 11.116 6.125 11ZM8.46875 11V5.3125C8.46875 5.19647 8.41936 5.08519 8.33146 5.00314C8.24355 4.92109 8.12432 4.875 8 4.875C7.87568 4.875 7.75645 4.92109 7.66854 5.00314C7.58064 5.08519 7.53125 5.19647 7.53125 5.3125V11C7.53125 11.116 7.58064 11.2273 7.66854 11.3094C7.75645 11.3914 7.87568 11.4375 8 11.4375C8.12432 11.4375 8.24355 11.3914 8.33146 11.3094C8.41936 11.2273 8.46875 11.116 8.46875 11ZM10.8125 11V5.3125C10.8125 5.19647 10.7631 5.08519 10.6752 5.00314C10.5873 4.92109 10.4681 4.875 10.3438 4.875C10.2194 4.875 10.1002 4.92109 10.0123 5.00314C9.92439 5.08519 9.875 5.19647 9.875 5.3125V11C9.875 11.116 9.92439 11.2273 10.0123 11.3094C10.1002 11.3914 10.2194 11.4375 10.3438 11.4375C10.4681 11.4375 10.5873 11.3914 10.6752 11.3094C10.7631 11.2273 10.8125 11.116 10.8125 11Z"
                      fill="#231815"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1533_23226">
                      <rect
                        width="15"
                        height="14"
                        fill="white"
                        transform="translate(0.5 0.5)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            )}
          </div>
          <div
            className="d-flex w-100"
            style={{ gap: isSmallScreen ? "2px" : "2px" }}
          >
            <AddToChat3 product={product} componentName={"productCard"} />
            <AddToList product={product} componentName={"productCard"} />
          </div>
        </div>
      </div>
    )
  );
};

export default ShoppingListCard2;
